import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, delay, firstValueFrom, map, of, switchMap } from 'rxjs';
import { ImportData } from '../models/UserInfo';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  constructor(
    private userService: UserService, 
    private router: Router,
    private authService: MsalService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkAdminStatus();
  }

  private checkAdminStatus(): Observable<boolean> {
    const users = this.authService.instance.getAllAccounts();
    return this.userService.getCurrentUserOb(users[0].username).pipe(
      map((userData: ImportData) => {
        if (!userData.IsAdmin) {
          this.router.navigate(['/invalid']);
          return false;
        }
        return true;
      })
    );
  }
}
